<svg
  *ngIf="src$ | async as src"
  [attr.viewBox]="store.getViewBoxString$(isInsideZoomPanel) | async"
  [class.round-container]="isInsideZoomPanel"
  [attr.preserveAspectRatio]="preserveAspectRatio"
>
  <foreignObject
    [attr.width]="store('sensorRendererState')('width').$ | async"
    [attr.height]="store('sensorRendererState')('height').$ | async"
  >
    <div xmlns="http://www.w3.org/1999/xhtml">
      <img
        class="logrocket-disable-recording"
        [src]="src"
        [style.filter]="filter$ | async"
        [attr.width]="store('sensorRendererState')('width').$ | async"
        [attr.height]="store('sensorRendererState')('height').$ | async"
        [style.image-rendering]="imageRendering$ | async"
        [crossOrigin]="crossOrigin$ | async"
      />
    </div>
  </foreignObject>
</svg>
